// extracted by mini-css-extract-plugin
export default {"head_table":"page_head_table__RIns6","table":"page_table__jr4U1","Table_head":"page_Table_head__ZhINv","body_table":"page_body_table__C3iQ6"};